<template>
  <div class="feature-flags-view">
    <FormGroup group-title="Helpers para testes">
      <FormItem>
        <Toggle v-model="enableServerSync">
          <OptionTitle>Desativar sincronização de horário</OptionTitle>
          <OptionInfo>
            <p>
              Por padrão, a aplicação usa o horário do servidor da Acerto. Quando esta opção está
              ativada, a aplicação passa a considerar o horário da máquina local.
            </p>
            <p>
              Obs.: é recomendado <em>recarregar a página</em> após alterar esta opção.
            </p>
          </OptionInfo>
        </Toggle>
      </FormItem>
    </FormGroup>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';

import { storageService } from '@/services';
import {
  FormGroup,
  FormItem,
  Toggle,
} from '../form';

import {
  OptionInfo,
  OptionTitle,
} from '../typography';

export default defineComponent({
  components: {
    FormGroup,
    FormItem,
    OptionInfo,
    OptionTitle,
    Toggle,
  },
  setup() {
    const enableServerSync = ref(storageService.skipServerSync.get());

    watch(
      enableServerSync,
      (newVal) => {
        if (newVal) storageService.skipServerSync.set(true);
        else storageService.skipServerSync.remove();
      },
    );

    return {
      enableServerSync,
    };
  },
});
</script>

<style scoped lang="scss">
em {
  text-decoration: underline #888;
  font-style: normal;
}
</style>
